<template>
  <div class="space-y-2" data-business-hours-grid>
    <div v-for="day in DAYS" :key="day.key" class="flex items-center gap-2">
      <span class="form-label w-10 shrink-0">{{ day.short }}</span>
      <select
        :value="rows[day.key].status"
        class="form-input text-sm py-1"
        :aria-label="`${day.short} status`"
        @change="setStatus(day.key, $event.target.value)">
        <option value="open">
          Open
        </option>
        <option value="closed">
          Closed
        </option>
        <option value="by_appointment">
          By appt
        </option>
      </select>
      <template v-if="rows[day.key].status === 'open'">
        <input
          type="time"
          :value="rows[day.key].open"
          class="form-input text-sm py-1"
          :aria-label="`${day.short} opens`"
          @change="setTime(day.key, 'open', $event.target.value)">
        <span class="text-gray-400">–</span>
        <input
          type="time"
          :value="rows[day.key].close"
          class="form-input text-sm py-1"
          :aria-label="`${day.short} closes`"
          @change="setTime(day.key, 'close', $event.target.value)">
      </template>
    </div>
  </div>
</template>

<script setup>
import { reactive, watch } from 'vue'

const DAYS = [
  { key: 'monday', short: 'Mon' }, { key: 'tuesday', short: 'Tue' },
  { key: 'wednesday', short: 'Wed' }, { key: 'thursday', short: 'Thu' },
  { key: 'friday', short: 'Fri' }, { key: 'saturday', short: 'Sat' },
  { key: 'sunday', short: 'Sun' }
]

const props = defineProps({
  modelValue: { type: Object, default: () => ({}) }
})
const emit = defineEmits(['update:modelValue'])

// Local per-day state covering all 7 days (missing days default to closed; open
// days default to 9–5 the first time they're toggled on).
function normalize(value) {
  const out = {}
  DAYS.forEach(({ key }) => {
    const entry = (value && value[key]) || {}
    const status = ['open', 'closed', 'by_appointment'].includes(entry.status) ? entry.status : 'closed'
    out[key] = { status, open: entry.open || '09:00', close: entry.close || '17:00' }
  })
  return out
}

const rows = reactive(normalize(props.modelValue))

// Reflect external resets (e.g. a server round-trip) back into the grid.
watch(() => props.modelValue, (val) => Object.assign(rows, normalize(val)))

function setStatus(key, status) {
  rows[key].status = status
  emitValue()
}

function setTime(key, which, value) {
  rows[key][which] = value
  emitValue()
}

// Emit the canonical {day => {status[, open, close]}} hash the API stores.
function emitValue() {
  const out = {}
  DAYS.forEach(({ key }) => {
    const r = rows[key]
    out[key] = r.status === 'open' ? { status: 'open', open: r.open, close: r.close } : { status: r.status }
  })
  emit('update:modelValue', out)
}
</script>
